/**
 * Generated by scripts/generate-drizzle-schema.mjs. Do not edit by hand.
 * This product's inputs: scripts/drizzle-schema.config.mjs.
 * Regenerate: bash scripts/client-schema-fresh.sh (data-model-change skill).
 */

import { DrizzleAppSchema, type PowerSyncSQLiteDatabase } from "@powersync/drizzle-driver";
import { index, integer, real, sqliteTable, text } from "drizzle-orm/sqlite-core";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";

export const announcement = sqliteTable(
  "announcement",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    campus_id: text("campus_id"),
    cohort_id: text("cohort_id"),
    course_id: text("course_id"),
    author_id: text("author_id"),
    title: text("title"),
    body: text("body"),
    pinned: integer("pinned"),
    publish_at: text("publish_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
    is_published: integer("is_published"),
  },
  (table) => [
    /** WHERE organization_id = ? (academy's board) */
    index("announcement_by_org").on(table.organization_id),
    /** WHERE cohort_id = ? (cohort's board) */
    index("announcement_by_cohort").on(table.cohort_id),
  ],
);

export const assignment = sqliteTable(
  "assignment",
  {
    id: text("id").primaryKey(),
    course_id: text("course_id"),
    organization_id: text("organization_id"),
    title: text("title"),
    instructions: text("instructions"),
    kind: text("kind"),
    max_score: real("max_score"),
    rubric: text("rubric"),
    submission_type: text("submission_type"),
    group_mode: integer("group_mode"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
    is_final_project: integer("is_final_project"),
    rubric_published: integer("rubric_published"),
    single_correction: integer("single_correction"),
  },
  (table) => [
    /** WHERE course_id = ? (course assignments) */
    index("assignment_by_course").on(table.course_id),
  ],
);

export const assignment_grade = sqliteTable(
  "assignment_grade",
  {
    id: text("id").primaryKey(),
    assignment_id: text("assignment_id"),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    user_id: text("user_id"),
    submission_id: text("submission_id"),
    score: real("score"),
    rubric_scores: text("rubric_scores"),
    feedback: text("feedback"),
    status: text("status"),
    graded_by: text("graded_by"),
    graded_at: text("graded_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    approved_version: integer("approved_version"),
    revision_count: integer("revision_count"),
  },
  (table) => [
    /** WHERE assignment_id = ? AND cohort_id = ? (grades for an assignment) */
    index("assignment_grade_by_assignment").on(table.assignment_id, table.cohort_id),
    /** WHERE user_id = ? (my grades) */
    index("assignment_grade_by_user").on(table.user_id),
  ],
);

export const assignment_review_policy = sqliteTable("assignment_review_policy", {
  id: text("id").primaryKey(),
  assignment_id: text("assignment_id"),
  organization_id: text("organization_id"),
  allow_resubmission: integer("allow_resubmission"),
  max_versions: integer("max_versions"),
  sla_days: integer("sla_days"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const assignment_submission = sqliteTable(
  "assignment_submission",
  {
    id: text("id").primaryKey(),
    assignment_id: text("assignment_id"),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    user_id: text("user_id"),
    group_id: text("group_id"),
    body: text("body"),
    files: text("files"),
    submitted_at: text("submitted_at"),
    late: integer("late"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE assignment_id = ? AND cohort_id = ? (submissions for an assignment) */
    index("assignment_submission_by_assignment").on(table.assignment_id, table.cohort_id),
    /** WHERE user_id = ? (my submissions) */
    index("assignment_submission_by_user").on(table.user_id),
  ],
);

export const attendance_record = sqliteTable(
  "attendance_record",
  {
    id: text("id").primaryKey(),
    class_session_id: text("class_session_id"),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    campus_id: text("campus_id"),
    user_id: text("user_id"),
    status: text("status"),
    method: text("method"),
    recorded_by: text("recorded_by"),
    recorded_at: text("recorded_at"),
    note: text("note"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE class_session_id = ? (roll call) */
    index("attendance_record_by_session").on(table.class_session_id),
    /** WHERE user_id = ? (my attendance) */
    index("attendance_record_by_user").on(table.user_id),
  ],
);

export const badge_award = sqliteTable(
  "badge_award",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    badge_id: text("badge_id"),
    organization_id: text("organization_id"),
    context_key: text("context_key"),
    context: text("context"),
    awarded_at: text("awarded_at"),
  },
  (table) => [
    /** WHERE user_id = ? (my badges) */
    index("badge_award_by_user").on(table.user_id),
  ],
);

export const block = sqliteTable(
  "block",
  {
    id: text("id").primaryKey(),
    lesson_id: text("lesson_id"),
    course_id: text("course_id"),
    kind: text("kind"),
    position: integer("position"),
    weight: integer("weight"),
    content: text("content"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE lesson_id = ? ORDER BY position in the player/editor */
    index("block_by_lesson").on(table.lesson_id, table.position),
  ],
);

export const campus = sqliteTable(
  "campus",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    name: text("name"),
    slug: text("slug"),
    address: text("address"),
    city: text("city"),
    state: text("state"),
    phone: text("phone"),
    timezone: text("timezone"),
    status: text("status"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE organization_id = ? (academy's campuses) */
    index("campus_by_org").on(table.organization_id),
  ],
);

export const certificate = sqliteTable(
  "certificate",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    course_id: text("course_id"),
    learner_name: text("learner_name"),
    course_title: text("course_title"),
    course_version: integer("course_version"),
    org_name: text("org_name"),
    issued_at: text("issued_at"),
    revoked_at: text("revoked_at"),
    cohort_code: text("cohort_code"),
    final_grade: real("final_grade"),
    final_grade_scheme: text("final_grade_scheme"),
    campus_name: text("campus_name"),
    final_grade_display: text("final_grade_display"),
    scope_kind: text("scope_kind"),
    track_id: text("track_id"),
    stage_id: text("stage_id"),
    stage_title: text("stage_title"),
    track_name: text("track_name"),
  },
  (table) => [
    /** WHERE user_id = ? (my certificates) and lookup by course */
    index("certificate_by_user").on(table.user_id, table.course_id),
  ],
);

export const class_session = sqliteTable(
  "class_session",
  {
    id: text("id").primaryKey(),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    campus_id: text("campus_id"),
    room_id: text("room_id"),
    teacher_id: text("teacher_id"),
    schedule_slot_id: text("schedule_slot_id"),
    date: text("date"),
    start_time: text("start_time"),
    end_time: text("end_time"),
    status: text("status"),
    topic: text("topic"),
    notes: text("notes"),
    checkin_open: integer("checkin_open"),
    meeting_provider: text("meeting_provider"),
    recording_video_id: text("recording_video_id"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE cohort_id = ? ORDER BY date (agenda) */
    index("class_session_by_cohort_date").on(table.cohort_id, table.date),
    /** WHERE campus_id = ? (campus occupancy) */
    index("class_session_by_campus").on(table.campus_id),
  ],
);

export const cohort = sqliteTable(
  "cohort",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    course_id: text("course_id"),
    program_id: text("program_id"),
    campus_id: text("campus_id"),
    code: text("code"),
    name: text("name"),
    modality: text("modality"),
    start_date: text("start_date"),
    end_date: text("end_date"),
    capacity: integer("capacity"),
    enrollment_rule: text("enrollment_rule"),
    status: text("status"),
    grading_scheme: text("grading_scheme"),
    completion_config: text("completion_config"),
    config: text("config"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
    grading_model_id: text("grading_model_id"),
    chat_locked: integer("chat_locked"),
    timezone: text("timezone"),
  },
  (table) => [
    /** WHERE organization_id = ? (academy cohorts) */
    index("cohort_by_org").on(table.organization_id),
    /** WHERE course_id = ? (course editions) */
    index("cohort_by_course").on(table.course_id),
  ],
);

export const cohort_chat_message = sqliteTable("cohort_chat_message", {
  id: text("id").primaryKey(),
  cohort_id: text("cohort_id"),
  organization_id: text("organization_id"),
  author_id: text("author_id"),
  body: text("body"),
  pinned_at: text("pinned_at"),
  promoted_thread_id: text("promoted_thread_id"),
  hidden_at: text("hidden_at"),
  hidden_by: text("hidden_by"),
  archived_at: text("archived_at"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const cohort_chat_reaction = sqliteTable("cohort_chat_reaction", {
  id: text("id").primaryKey(),
  message_id: text("message_id"),
  cohort_id: text("cohort_id"),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  emoji: text("emoji"),
  created_at: text("created_at"),
});

export const cohort_chat_read = sqliteTable("cohort_chat_read", {
  id: text("id").primaryKey(),
  cohort_id: text("cohort_id"),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  last_read_at: text("last_read_at"),
  muted_until: text("muted_until"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const cohort_enrollment = sqliteTable(
  "cohort_enrollment",
  {
    id: text("id").primaryKey(),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    campus_id: text("campus_id"),
    user_id: text("user_id"),
    status: text("status"),
    waitlist_position: integer("waitlist_position"),
    enrolled_at: text("enrolled_at"),
    completed_at: text("completed_at"),
    withdrawn_at: text("withdrawn_at"),
    final_grade: real("final_grade"),
    final_grade_scheme: text("final_grade_scheme"),
    notes: text("notes"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
    sessions_present: integer("sessions_present"),
    sessions_late: integer("sessions_late"),
    sessions_absent: integer("sessions_absent"),
    sessions_excused: integer("sessions_excused"),
    absence_streak: integer("absence_streak"),
    attendance_rate: real("attendance_rate"),
    completion_manual: integer("completion_manual"),
  },
  (table) => [
    /** WHERE cohort_id = ? AND status = 'active' (roster) */
    index("cohort_enrollment_by_cohort").on(table.cohort_id, table.status),
    /** WHERE user_id = ? (my cohorts) */
    index("cohort_enrollment_by_user").on(table.user_id),
  ],
);

export const cohort_group = sqliteTable(
  "cohort_group",
  {
    id: text("id").primaryKey(),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    name: text("name"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE cohort_id = ? (cohort teams) */
    index("cohort_group_by_cohort").on(table.cohort_id),
  ],
);

export const cohort_group_member = sqliteTable(
  "cohort_group_member",
  {
    id: text("id").primaryKey(),
    group_id: text("group_id"),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    user_id: text("user_id"),
    created_at: text("created_at"),
  },
  (table) => [
    /** WHERE group_id = ? (team members) */
    index("cohort_group_member_by_group").on(table.group_id),
  ],
);

export const cohort_module_setting = sqliteTable(
  "cohort_module_setting",
  {
    id: text("id").primaryKey(),
    cohort_id: text("cohort_id"),
    module_id: text("module_id"),
    organization_id: text("organization_id"),
    due_at: text("due_at"),
    open_at: text("open_at"),
    visibility: text("visibility"),
    config: text("config"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE cohort_id = ? (per-module dates) */
    index("cohort_module_setting_by_cohort").on(table.cohort_id),
  ],
);

export const cohort_teacher = sqliteTable(
  "cohort_teacher",
  {
    id: text("id").primaryKey(),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    user_id: text("user_id"),
    role: text("role"),
    created_at: text("created_at"),
  },
  (table) => [
    /** WHERE cohort_id = ? (cohort's teaching staff) */
    index("cohort_teacher_by_cohort").on(table.cohort_id),
  ],
);

export const course = sqliteTable(
  "course",
  {
    id: text("id").primaryKey(),
    author_id: text("author_id"),
    title: text("title"),
    description: text("description"),
    slug: text("slug"),
    category: text("category"),
    cover_image: text("cover_image"),
    language: text("language"),
    visibility: text("visibility"),
    version: integer("version"),
    published_at: text("published_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE author_id = ? in the authoring editor */
    index("course_by_author").on(table.author_id),
    /** Catalog: WHERE visibility = 'public' */
    index("course_by_visibility").on(table.visibility),
  ],
);

export const course_editor = sqliteTable("course_editor", {
  id: text("id").primaryKey(),
  course_id: text("course_id"),
  user_id: text("user_id"),
  created_at: text("created_at"),
});

export const course_module = sqliteTable(
  "course_module",
  {
    id: text("id").primaryKey(),
    unit_id: text("unit_id"),
    course_id: text("course_id"),
    kind: text("kind"),
    ref_id: text("ref_id"),
    position: integer("position"),
    visibility: text("visibility"),
    completion_rule: text("completion_rule"),
    config: text("config"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
    access_tier: text("access_tier"),
  },
  (table) => [
    /** WHERE unit_id = ? ORDER BY position (course spine) */
    index("course_module_by_unit").on(table.unit_id, table.position),
    /** WHERE course_id = ? */
    index("course_module_by_course").on(table.course_id),
  ],
);

export const course_settings = sqliteTable("course_settings", {
  id: text("id").primaryKey(),
  grading_scheme: text("grading_scheme"),
  enabled_module_kinds: text("enabled_module_kinds"),
  meeting_provider: text("meeting_provider"),
  completion_config: text("completion_config"),
  forum_policy: text("forum_policy"),
  features: text("features"),
  media_settings: text("media_settings"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  grading_model_id: text("grading_model_id"),
});

export const enrollment = sqliteTable(
  "enrollment",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    course_id: text("course_id"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE user_id = ? in my courses + getHasLocalDataQuery */
    index("enrollment_by_user").on(table.user_id),
  ],
);

export const entitled_course = sqliteTable(
  "entitled_course",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    course_id: text("course_id"),
    organization_id: text("organization_id"),
    tier: text("tier"),
    frozen_since: text("frozen_since"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE course_id = ? when opening a course (frozen?) */
    index("entitled_course_by_course").on(table.course_id),
  ],
);

export const entitlement_state = sqliteTable(
  "entitlement_state",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    organization_id: text("organization_id"),
    scope_level: text("scope_level"),
    scope_id: text("scope_id"),
    state: text("state"),
    restrictions: text("restrictions"),
    source_level: text("source_level"),
    source_label: text("source_label"),
    grant_kind: text("grant_kind"),
    reason_code: text("reason_code"),
    blocked_since: text("blocked_since"),
    unblocks_at: text("unblocks_at"),
    computed_at: text("computed_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE organization_id = ? in the active academy banner */
    index("entitlement_state_by_org").on(table.organization_id),
  ],
);

export const font_family = sqliteTable("font_family", {
  id: text("id").primaryKey(),
  family: text("family"),
  name: text("name"),
  category: text("category"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const font_variant = sqliteTable("font_variant", {
  id: text("id").primaryKey(),
  font_family_id: text("font_family_id"),
  weight: text("weight"),
  url: text("url"),
  created_at: text("created_at"),
  attachment_id: text("attachment_id"),
});

export const forum = sqliteTable(
  "forum",
  {
    id: text("id").primaryKey(),
    module_id: text("module_id"),
    course_id: text("course_id"),
    organization_id: text("organization_id"),
    title: text("title"),
    locked: integer("locked"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE course_id = ? (course forums) */
    index("forum_by_course").on(table.course_id),
  ],
);

export const forum_post = sqliteTable(
  "forum_post",
  {
    id: text("id").primaryKey(),
    thread_id: text("thread_id"),
    forum_id: text("forum_id"),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    author_id: text("author_id"),
    body: text("body"),
    reply_to_id: text("reply_to_id"),
    hidden_at: text("hidden_at"),
    hidden_by: text("hidden_by"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE thread_id = ? (thread messages) */
    index("forum_post_by_thread").on(table.thread_id),
  ],
);

export const forum_thread = sqliteTable(
  "forum_thread",
  {
    id: text("id").primaryKey(),
    forum_id: text("forum_id"),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    author_id: text("author_id"),
    title: text("title"),
    pinned: integer("pinned"),
    locked: integer("locked"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE forum_id = ? (forum threads) */
    index("forum_thread_by_forum").on(table.forum_id),
    /** WHERE cohort_id = ? */
    index("forum_thread_by_cohort").on(table.cohort_id),
  ],
);

export const grade_category = sqliteTable(
  "grade_category",
  {
    id: text("id").primaryKey(),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    name: text("name"),
    weight: real("weight"),
    drop_lowest: integer("drop_lowest"),
    position: integer("position"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE cohort_id = ? (gradebook categories) */
    index("grade_category_by_cohort").on(table.cohort_id),
  ],
);

export const grade_item = sqliteTable(
  "grade_item",
  {
    id: text("id").primaryKey(),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    category_id: text("category_id"),
    source_kind: text("source_kind"),
    source_ref: text("source_ref"),
    name: text("name"),
    max_score: real("max_score"),
    weight: real("weight"),
    position: integer("position"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE cohort_id = ? (gradebook items) */
    index("grade_item_by_cohort").on(table.cohort_id),
  ],
);

export const grading_model = sqliteTable(
  "grading_model",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    name: text("name"),
    kind: text("kind"),
    max_value: real("max_value"),
    passing_threshold: real("passing_threshold"),
    decimals: integer("decimals"),
    letter_bands: text("letter_bands"),
    display_suffix: text("display_suffix"),
    is_system: integer("is_system"),
    system_key: text("system_key"),
    created_by: text("created_by"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE organization_id = ? (academy's grading models) */
    index("grading_model_by_org").on(table.organization_id),
  ],
);

export const guardian_link = sqliteTable(
  "guardian_link",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    guardian_user_id: text("guardian_user_id"),
    student_user_id: text("student_user_id"),
    relationship: text("relationship"),
    is_primary: integer("is_primary"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    consent_status: text("consent_status"),
    consent_scopes: text("consent_scopes"),
    consent_granted_at: text("consent_granted_at"),
    consent_revoked_at: text("consent_revoked_at"),
    consent_expires_at: text("consent_expires_at"),
    consent_method: text("consent_method"),
    consent_evidence: text("consent_evidence"),
    consent_recorded_by: text("consent_recorded_by"),
    consent_policy_version: text("consent_policy_version"),
  },
  (table) => [
    /** WHERE student_user_id = ? (student's guardians) */
    index("guardian_link_by_student").on(table.student_user_id),
  ],
);

export const leaderboard_entry = sqliteTable(
  "leaderboard_entry",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    league_id: text("league_id"),
    display_name: text("display_name"),
    total_xp: integer("total_xp"),
    opted_in: integer("opted_in"),
    updated_at: text("updated_at"),
    league_rank: integer("league_rank"),
  },
  (table) => [
    /** Ranking per league: WHERE league_id = ? ORDER BY league_rank */
    index("leaderboard_entry_by_league").on(table.league_id, table.league_rank),
  ],
);

export const learner_stats = sqliteTable("learner_stats", {
  id: text("id").primaryKey(),
  user_id: text("user_id"),
  total_xp: integer("total_xp"),
  lessons_done: integer("lessons_done"),
  current_streak: integer("current_streak"),
  longest_streak: integer("longest_streak"),
  last_active_date: text("last_active_date"),
  updated_at: text("updated_at"),
});

export const lesson = sqliteTable(
  "lesson",
  {
    id: text("id").primaryKey(),
    unit_id: text("unit_id"),
    course_id: text("course_id"),
    title: text("title"),
    position: integer("position"),
    xp_reward: integer("xp_reward"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
    access_tier: text("access_tier"),
  },
  (table) => [
    /** WHERE unit_id = ? ORDER BY position */
    index("lesson_by_unit").on(table.unit_id, table.position),
    /** WHERE course_id = ? */
    index("lesson_by_course").on(table.course_id),
  ],
);

export const lesson_progress = sqliteTable(
  "lesson_progress",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    course_id: text("course_id"),
    lesson_id: text("lesson_id"),
    status: text("status"),
    score: real("score"),
    xp_awarded: integer("xp_awarded"),
    attempts: integer("attempts"),
    last_block_id: text("last_block_id"),
    fraud_flags: text("fraud_flags"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    completed_at: text("completed_at"),
    /** Client-only: travels in sync's opData; Postgres doesn't have it. */
    claimed_score: real("claimed_score"),
    /** Client-only: travels in sync's opData; Postgres doesn't have it. */
    responses: text("responses"),
    /** Client-only: travels in sync's opData; Postgres doesn't have it. */
    started_at: integer("started_at"),
    /** Client-only: travels in sync's opData; Postgres doesn't have it. */
    finished_at: integer("finished_at"),
  },
  (table) => [
    /** WHERE user_id = ? in getHasLocalDataQuery */
    index("lesson_progress_by_user").on(table.user_id),
    /** WHERE user_id = ? AND course_id = ? in course progress */
    index("lesson_progress_by_course").on(table.user_id, table.course_id),
  ],
);

// Small per-user dataset — indexes not needed for now.
export const member = sqliteTable("member", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  role: text("role"),
  created_at: text("created_at"),
  campus_id: text("campus_id"),
});

export const notification = sqliteTable(
  "notification",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    organization_id: text("organization_id"),
    kind: text("kind"),
    payload: text("payload"),
    read_at: text("read_at"),
    created_at: text("created_at"),
  },
  (table) => [
    /** WHERE user_id = ? AND read_at IS NULL (inbox) */
    index("notification_by_user").on(table.user_id, table.read_at),
  ],
);

export const org_settings = sqliteTable("org_settings", {
  id: text("id").primaryKey(),
  country: text("country"),
  timezone: text("timezone"),
  locale: text("locale"),
  currency_primary: text("currency_primary"),
  currency_secondary: text("currency_secondary"),
  exchange_rate: real("exchange_rate"),
  exchange_rate_updated_at: text("exchange_rate_updated_at"),
  grading_scheme: text("grading_scheme"),
  attendance_alert_threshold: integer("attendance_alert_threshold"),
  features: text("features"),
  country_pack: text("country_pack"),
  branding: text("branding"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  grading_model_id: text("grading_model_id"),
  progression_config: text("progression_config"),
  adult_age: integer("adult_age"),
  /** Client-only: travels in sync's opData; Postgres doesn't have it. */
  asserted_fields: text("asserted_fields"),
});

// Small dataset — indexes not needed for now.
export const organization = sqliteTable("organization", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  logo: text("logo"),
  metadata: text("metadata"),
  created_at: text("created_at"),
});

export const program = sqliteTable(
  "program",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    name: text("name"),
    description: text("description"),
    kind: text("kind"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE organization_id = ? (academy programs) */
    index("program_by_org").on(table.organization_id),
  ],
);

export const program_course = sqliteTable(
  "program_course",
  {
    id: text("id").primaryKey(),
    program_id: text("program_id"),
    organization_id: text("organization_id"),
    course_id: text("course_id"),
    position: integer("position"),
    required: integer("required"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE program_id = ? ORDER BY position */
    index("program_course_by_program").on(table.program_id, table.position),
  ],
);

export const question = sqliteTable(
  "question",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    course_id: text("course_id"),
    author_id: text("author_id"),
    kind: text("kind"),
    content: text("content"),
    tags: text("tags"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE organization_id = ? (question bank) */
    index("question_by_org").on(table.organization_id),
  ],
);

export const resource = sqliteTable(
  "resource",
  {
    id: text("id").primaryKey(),
    course_id: text("course_id"),
    organization_id: text("organization_id"),
    kind: text("kind"),
    title: text("title"),
    url: text("url"),
    storage_key: text("storage_key"),
    body: text("body"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE course_id = ? (course material) */
    index("resource_by_course").on(table.course_id),
  ],
);

export const room = sqliteTable(
  "room",
  {
    id: text("id").primaryKey(),
    campus_id: text("campus_id"),
    organization_id: text("organization_id"),
    name: text("name"),
    capacity: integer("capacity"),
    floor: text("floor"),
    equipment: text("equipment"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE campus_id = ? (campus rooms) */
    index("room_by_campus").on(table.campus_id),
  ],
);

export const schedule_slot = sqliteTable(
  "schedule_slot",
  {
    id: text("id").primaryKey(),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    campus_id: text("campus_id"),
    room_id: text("room_id"),
    weekday: integer("weekday"),
    start_time: text("start_time"),
    end_time: text("end_time"),
    teacher_id: text("teacher_id"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE cohort_id = ? (weekly schedule) */
    index("schedule_slot_by_cohort").on(table.cohort_id),
  ],
);

// User's active sessions — small dataset, no indexes.
export const session = sqliteTable("session", {
  id: text("id").primaryKey(),
});

export const session_module = sqliteTable(
  "session_module",
  {
    id: text("id").primaryKey(),
    class_session_id: text("class_session_id"),
    module_id: text("module_id"),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    campus_id: text("campus_id"),
    phase: text("phase"),
    position: integer("position"),
    config: text("config"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE class_session_id = ? ORDER BY phase, position (lesson plan) */
    index("session_module_by_session").on(table.class_session_id, table.phase, table.position),
    /** WHERE cohort_id = ? */
    index("session_module_by_cohort").on(table.cohort_id),
  ],
);

export const student_alert = sqliteTable(
  "student_alert",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    campus_id: text("campus_id"),
    cohort_id: text("cohort_id"),
    user_id: text("user_id"),
    kind: text("kind"),
    payload: text("payload"),
    status: text("status"),
    acknowledged_by: text("acknowledged_by"),
    acknowledged_at: text("acknowledged_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE cohort_id = ? (cohort's risk alerts) */
    index("student_alert_by_cohort").on(table.cohort_id),
    /** WHERE user_id = ? */
    index("student_alert_by_user").on(table.user_id),
  ],
);

export const student_profile = sqliteTable(
  "student_profile",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    organization_id: text("organization_id"),
    campus_id: text("campus_id"),
    national_id: text("national_id"),
    birth_date: text("birth_date"),
    phone: text("phone"),
    address: text("address"),
    emergency_contact: text("emergency_contact"),
    notes: text("notes"),
    custom_fields: text("custom_fields"),
    status: text("status"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE organization_id = ? (student directory) */
    index("student_profile_by_org").on(table.organization_id),
  ],
);

export const submission_version = sqliteTable(
  "submission_version",
  {
    id: text("id").primaryKey(),
    assignment_id: text("assignment_id"),
    cohort_id: text("cohort_id"),
    organization_id: text("organization_id"),
    user_id: text("user_id"),
    group_id: text("group_id"),
    version: integer("version"),
    body: text("body"),
    files: text("files"),
    submitted_at: text("submitted_at"),
    feedback: text("feedback"),
    feedback_by: text("feedback_by"),
    feedback_at: text("feedback_at"),
    outcome: text("outcome"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE assignment_id = ? AND cohort_id = ? */
    index("submission_version_by_assignment").on(table.assignment_id, table.cohort_id),
    /** WHERE user_id = ? (my versions) */
    index("submission_version_by_user").on(table.user_id),
    /** WHERE cohort_id = ? */
    index("submission_version_by_cohort").on(table.cohort_id),
  ],
);

export const teacher_profile = sqliteTable(
  "teacher_profile",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    organization_id: text("organization_id"),
    title: text("title"),
    bio: text("bio"),
    specialties: text("specialties"),
    photo: text("photo"),
    public_slug: text("public_slug"),
    is_public: integer("is_public"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE organization_id = ? (faculty) */
    index("teacher_profile_by_org").on(table.organization_id),
  ],
);

// Small global dataset (~20 themes) — indexes not needed.
export const themes = sqliteTable("themes", {
  id: text("id").primaryKey(),
  name: text("name"),
  background: text("background"),
  surface: text("surface"),
  accent: text("accent"),
  glow_colors: text("glow_colors"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  is_dark: integer("is_dark"),
  foreground: text("foreground"),
  field_background: text("field_background"),
  danger: text("danger"),
  success: text("success"),
  warning: text("warning"),
  muted: text("muted"),
  pattern_type: text("pattern_type"),
  pattern_opacity: integer("pattern_opacity"),
  pair_id: text("pair_id"),
  font_normal: text("font_normal"),
  font_medium: text("font_medium"),
  font_semibold: text("font_semibold"),
  font_bold: text("font_bold"),
  radius: text("radius"),
  surface_foreground: text("surface_foreground"),
  surface_secondary: text("surface_secondary"),
  surface_secondary_foreground: text("surface_secondary_foreground"),
  surface_tertiary: text("surface_tertiary"),
  surface_tertiary_foreground: text("surface_tertiary_foreground"),
  overlay: text("overlay"),
  overlay_foreground: text("overlay_foreground"),
  default: text("default"),
  default_foreground: text("default_foreground"),
  accent_foreground: text("accent_foreground"),
  field_foreground: text("field_foreground"),
  field_placeholder: text("field_placeholder"),
  field_border: text("field_border"),
  danger_foreground: text("danger_foreground"),
  success_foreground: text("success_foreground"),
  warning_foreground: text("warning_foreground"),
  segment: text("segment"),
  segment_foreground: text("segment_foreground"),
  border: text("border"),
  focus: text("focus"),
  link: text("link"),
  surface_shadow: text("surface_shadow"),
  overlay_shadow: text("overlay_shadow"),
  field_shadow: text("field_shadow"),
  muted_foreground: text("muted_foreground"),
  divider: text("divider"),
  glass_background: text("glass_background"),
  glass_border: text("glass_border"),
  glass_highlight: text("glass_highlight"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
});

export const tutoring_settings = sqliteTable("tutoring_settings", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  sla_days: integer("sla_days"),
  allow_resubmission: integer("allow_resubmission"),
  max_versions: integer("max_versions"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const unit = sqliteTable(
  "unit",
  {
    id: text("id").primaryKey(),
    course_id: text("course_id"),
    title: text("title"),
    position: integer("position"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE course_id = ? ORDER BY position in the course tree */
    index("unit_by_course").on(table.course_id, table.position),
  ],
);

// Only 1 row per user — indexes not needed.
export const user = sqliteTable("user", {
  id: text("id").primaryKey(),
  name: text("name"),
  email: text("email"),
  email_verified: integer("email_verified"),
  image: text("image"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  locale: text("locale"),
  global_theme_id: text("global_theme_id"),
  is_blur: integer("is_blur"),
  font_family: text("font_family"),
  follow_device_theme: integer("follow_device_theme"),
  role: text("role"),
  leaderboard_opt_in: integer("leaderboard_opt_in"),
});

export const video_asset = sqliteTable(
  "video_asset",
  {
    id: text("id").primaryKey(),
    owner_user_id: text("owner_user_id"),
    organization_id: text("organization_id"),
    course_id: text("course_id"),
    lesson_id: text("lesson_id"),
    class_session_id: text("class_session_id"),
    title: text("title"),
    original_filename: text("original_filename"),
    content_type: text("content_type"),
    size_bytes: integer("size_bytes"),
    duration_seconds: real("duration_seconds"),
    poster_key: text("poster_key"),
    playback_kind: text("playback_kind"),
    variants: text("variants"),
    status: text("status"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE course_id = ? (course videos) */
    index("video_asset_by_course").on(table.course_id),
    /** WHERE class_session_id = ? (class recording) */
    index("video_asset_by_session").on(table.class_session_id),
    /** WHERE organization_id = ? (academy library) */
    index("video_asset_by_org").on(table.organization_id),
  ],
);

export const video_watch_progress = sqliteTable(
  "video_watch_progress",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    video_id: text("video_id"),
    position_seconds: real("position_seconds"),
    watched_pct: real("watched_pct"),
    completed_at: text("completed_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE user_id = ? (where I left off) */
    index("video_watch_progress_by_user").on(table.user_id),
  ],
);

export const drizzleSchema = {
  announcement,
  assignment,
  assignment_grade,
  assignment_review_policy,
  assignment_submission,
  attendance_record,
  badge_award,
  block,
  campus,
  certificate,
  class_session,
  cohort,
  cohort_chat_message,
  cohort_chat_reaction,
  cohort_chat_read,
  cohort_enrollment,
  cohort_group,
  cohort_group_member,
  cohort_module_setting,
  cohort_teacher,
  course,
  course_editor,
  course_module,
  course_settings,
  enrollment,
  entitled_course,
  entitlement_state,
  font_family,
  font_variant,
  forum,
  forum_post,
  forum_thread,
  grade_category,
  grade_item,
  grading_model,
  guardian_link,
  leaderboard_entry,
  learner_stats,
  lesson,
  lesson_progress,
  member,
  notification,
  org_settings,
  organization,
  program,
  program_course,
  question,
  resource,
  room,
  schedule_slot,
  session,
  session_module,
  student_alert,
  student_profile,
  submission_version,
  teacher_profile,
  themes,
  tutoring_settings,
  unit,
  user,
  video_asset,
  video_watch_progress,
};

export const AppSchema = new DrizzleAppSchema(drizzleSchema);

export type Database = (typeof AppSchema)["types"];

/**
 * Type helper for the Drizzle database instance wrapped with PowerSync.
 */
export type PowerSyncDrizzleDB = PowerSyncSQLiteDatabase<typeof drizzleSchema>;

export const USER_DATA_TABLES = [
  "assignment_grade",
  "assignment_submission",
  "attendance_record",
  "badge_award",
  "cohort_chat_reaction",
  "cohort_chat_read",
  "cohort_enrollment",
  "enrollment",
  "entitled_course",
  "entitlement_state",
  "learner_stats",
  "lesson_progress",
  "notification",
  "submission_version",
  "video_watch_progress",
] as const;

export type Announcement = InferSelectModel<typeof announcement>;
export type AnnouncementInsert = InferInsertModel<typeof announcement>;
export type AnnouncementRecord = Announcement;
export type Assignment = InferSelectModel<typeof assignment>;
export type AssignmentInsert = InferInsertModel<typeof assignment>;
export type AssignmentRecord = Assignment;
export type AssignmentGrade = InferSelectModel<typeof assignment_grade>;
export type AssignmentGradeInsert = InferInsertModel<typeof assignment_grade>;
export type AssignmentGradeRecord = AssignmentGrade;
export type AssignmentReviewPolicy = InferSelectModel<typeof assignment_review_policy>;
export type AssignmentReviewPolicyInsert = InferInsertModel<typeof assignment_review_policy>;
export type AssignmentReviewPolicyRecord = AssignmentReviewPolicy;
export type AssignmentSubmission = InferSelectModel<typeof assignment_submission>;
export type AssignmentSubmissionInsert = InferInsertModel<typeof assignment_submission>;
export type AssignmentSubmissionRecord = AssignmentSubmission;
export type AttendanceRecord = InferSelectModel<typeof attendance_record>;
export type AttendanceRecordInsert = InferInsertModel<typeof attendance_record>;
export type AttendanceRecordRecord = AttendanceRecord;
export type BadgeAward = InferSelectModel<typeof badge_award>;
export type BadgeAwardInsert = InferInsertModel<typeof badge_award>;
export type BadgeAwardRecord = BadgeAward;
export type Block = InferSelectModel<typeof block>;
export type BlockInsert = InferInsertModel<typeof block>;
export type BlockRecord = Block;
export type Campus = InferSelectModel<typeof campus>;
export type CampusInsert = InferInsertModel<typeof campus>;
export type CampusRecord = Campus;
export type Certificate = InferSelectModel<typeof certificate>;
export type CertificateInsert = InferInsertModel<typeof certificate>;
export type CertificateRecord = Certificate;
export type ClassSession = InferSelectModel<typeof class_session>;
export type ClassSessionInsert = InferInsertModel<typeof class_session>;
export type ClassSessionRecord = ClassSession;
export type Cohort = InferSelectModel<typeof cohort>;
export type CohortInsert = InferInsertModel<typeof cohort>;
export type CohortRecord = Cohort;
export type CohortChatMessage = InferSelectModel<typeof cohort_chat_message>;
export type CohortChatMessageInsert = InferInsertModel<typeof cohort_chat_message>;
export type CohortChatMessageRecord = CohortChatMessage;
export type CohortChatReaction = InferSelectModel<typeof cohort_chat_reaction>;
export type CohortChatReactionInsert = InferInsertModel<typeof cohort_chat_reaction>;
export type CohortChatReactionRecord = CohortChatReaction;
export type CohortChatRead = InferSelectModel<typeof cohort_chat_read>;
export type CohortChatReadInsert = InferInsertModel<typeof cohort_chat_read>;
export type CohortChatReadRecord = CohortChatRead;
export type CohortEnrollment = InferSelectModel<typeof cohort_enrollment>;
export type CohortEnrollmentInsert = InferInsertModel<typeof cohort_enrollment>;
export type CohortEnrollmentRecord = CohortEnrollment;
export type CohortGroup = InferSelectModel<typeof cohort_group>;
export type CohortGroupInsert = InferInsertModel<typeof cohort_group>;
export type CohortGroupRecord = CohortGroup;
export type CohortGroupMember = InferSelectModel<typeof cohort_group_member>;
export type CohortGroupMemberInsert = InferInsertModel<typeof cohort_group_member>;
export type CohortGroupMemberRecord = CohortGroupMember;
export type CohortModuleSetting = InferSelectModel<typeof cohort_module_setting>;
export type CohortModuleSettingInsert = InferInsertModel<typeof cohort_module_setting>;
export type CohortModuleSettingRecord = CohortModuleSetting;
export type CohortTeacher = InferSelectModel<typeof cohort_teacher>;
export type CohortTeacherInsert = InferInsertModel<typeof cohort_teacher>;
export type CohortTeacherRecord = CohortTeacher;
export type Course = InferSelectModel<typeof course>;
export type CourseInsert = InferInsertModel<typeof course>;
export type CourseRecord = Course;
export type CourseEditor = InferSelectModel<typeof course_editor>;
export type CourseEditorInsert = InferInsertModel<typeof course_editor>;
export type CourseEditorRecord = CourseEditor;
export type CourseModule = InferSelectModel<typeof course_module>;
export type CourseModuleInsert = InferInsertModel<typeof course_module>;
export type CourseModuleRecord = CourseModule;
export type CourseSettings = InferSelectModel<typeof course_settings>;
export type CourseSettingsInsert = InferInsertModel<typeof course_settings>;
export type CourseSettingsRecord = CourseSettings;
export type Enrollment = InferSelectModel<typeof enrollment>;
export type EnrollmentInsert = InferInsertModel<typeof enrollment>;
export type EnrollmentRecord = Enrollment;
export type EntitledCourse = InferSelectModel<typeof entitled_course>;
export type EntitledCourseInsert = InferInsertModel<typeof entitled_course>;
export type EntitledCourseRecord = EntitledCourse;
export type EntitlementState = InferSelectModel<typeof entitlement_state>;
export type EntitlementStateInsert = InferInsertModel<typeof entitlement_state>;
export type EntitlementStateRecord = EntitlementState;
export type FontFamily = InferSelectModel<typeof font_family>;
export type FontFamilyInsert = InferInsertModel<typeof font_family>;
export type FontFamilyRecord = FontFamily;
export type FontVariant = InferSelectModel<typeof font_variant>;
export type FontVariantInsert = InferInsertModel<typeof font_variant>;
export type FontVariantRecord = FontVariant;
export type Forum = InferSelectModel<typeof forum>;
export type ForumInsert = InferInsertModel<typeof forum>;
export type ForumRecord = Forum;
export type ForumPost = InferSelectModel<typeof forum_post>;
export type ForumPostInsert = InferInsertModel<typeof forum_post>;
export type ForumPostRecord = ForumPost;
export type ForumThread = InferSelectModel<typeof forum_thread>;
export type ForumThreadInsert = InferInsertModel<typeof forum_thread>;
export type ForumThreadRecord = ForumThread;
export type GradeCategory = InferSelectModel<typeof grade_category>;
export type GradeCategoryInsert = InferInsertModel<typeof grade_category>;
export type GradeCategoryRecord = GradeCategory;
export type GradeItem = InferSelectModel<typeof grade_item>;
export type GradeItemInsert = InferInsertModel<typeof grade_item>;
export type GradeItemRecord = GradeItem;
export type GradingModel = InferSelectModel<typeof grading_model>;
export type GradingModelInsert = InferInsertModel<typeof grading_model>;
export type GradingModelRecord = GradingModel;
export type GuardianLink = InferSelectModel<typeof guardian_link>;
export type GuardianLinkInsert = InferInsertModel<typeof guardian_link>;
export type GuardianLinkRecord = GuardianLink;
export type LeaderboardEntryRow = InferSelectModel<typeof leaderboard_entry>;
export type LeaderboardEntryRowInsert = InferInsertModel<typeof leaderboard_entry>;
export type LeaderboardEntryRowRecord = LeaderboardEntryRow;
export type LearnerStats = InferSelectModel<typeof learner_stats>;
export type LearnerStatsInsert = InferInsertModel<typeof learner_stats>;
export type LearnerStatsRecord = LearnerStats;
export type Lesson = InferSelectModel<typeof lesson>;
export type LessonInsert = InferInsertModel<typeof lesson>;
export type LessonRecord = Lesson;
export type LessonProgress = InferSelectModel<typeof lesson_progress>;
export type LessonProgressInsert = InferInsertModel<typeof lesson_progress>;
export type LessonProgressRecord = LessonProgress;
export type Member = InferSelectModel<typeof member>;
export type MemberInsert = InferInsertModel<typeof member>;
export type MemberRecord = Member;
export type Notification = InferSelectModel<typeof notification>;
export type NotificationInsert = InferInsertModel<typeof notification>;
export type NotificationRecord = Notification;
export type OrgSettings = InferSelectModel<typeof org_settings>;
export type OrgSettingsInsert = InferInsertModel<typeof org_settings>;
export type OrgSettingsRecord = OrgSettings;
export type Organization = InferSelectModel<typeof organization>;
export type OrganizationInsert = InferInsertModel<typeof organization>;
export type OrganizationRecord = Organization;
export type Program = InferSelectModel<typeof program>;
export type ProgramInsert = InferInsertModel<typeof program>;
export type ProgramRecord = Program;
export type ProgramCourse = InferSelectModel<typeof program_course>;
export type ProgramCourseInsert = InferInsertModel<typeof program_course>;
export type ProgramCourseRecord = ProgramCourse;
export type Question = InferSelectModel<typeof question>;
export type QuestionInsert = InferInsertModel<typeof question>;
export type QuestionRecord = Question;
export type ResourceRow = InferSelectModel<typeof resource>;
export type ResourceRowInsert = InferInsertModel<typeof resource>;
export type ResourceRowRecord = ResourceRow;
export type Room = InferSelectModel<typeof room>;
export type RoomInsert = InferInsertModel<typeof room>;
export type RoomRecord = Room;
export type ScheduleSlot = InferSelectModel<typeof schedule_slot>;
export type ScheduleSlotInsert = InferInsertModel<typeof schedule_slot>;
export type ScheduleSlotRecord = ScheduleSlot;
export type Session = InferSelectModel<typeof session>;
export type SessionInsert = InferInsertModel<typeof session>;
export type SessionRecord = Session;
export type SessionModule = InferSelectModel<typeof session_module>;
export type SessionModuleInsert = InferInsertModel<typeof session_module>;
export type SessionModuleRecord = SessionModule;
export type StudentAlert = InferSelectModel<typeof student_alert>;
export type StudentAlertInsert = InferInsertModel<typeof student_alert>;
export type StudentAlertRecord = StudentAlert;
export type StudentProfile = InferSelectModel<typeof student_profile>;
export type StudentProfileInsert = InferInsertModel<typeof student_profile>;
export type StudentProfileRecord = StudentProfile;
export type SubmissionVersion = InferSelectModel<typeof submission_version>;
export type SubmissionVersionInsert = InferInsertModel<typeof submission_version>;
export type SubmissionVersionRecord = SubmissionVersion;
export type TeacherProfile = InferSelectModel<typeof teacher_profile>;
export type TeacherProfileInsert = InferInsertModel<typeof teacher_profile>;
export type TeacherProfileRecord = TeacherProfile;
export type Themes = InferSelectModel<typeof themes>;
export type ThemesInsert = InferInsertModel<typeof themes>;
export type ThemesRecord = Themes;
export type TutoringSettings = InferSelectModel<typeof tutoring_settings>;
export type TutoringSettingsInsert = InferInsertModel<typeof tutoring_settings>;
export type TutoringSettingsRecord = TutoringSettings;
export type Unit = InferSelectModel<typeof unit>;
export type UnitInsert = InferInsertModel<typeof unit>;
export type UnitRecord = Unit;
export type User = InferSelectModel<typeof user>;
export type UserInsert = InferInsertModel<typeof user>;
export type UserRecord = User;
export type VideoAsset = InferSelectModel<typeof video_asset>;
export type VideoAssetInsert = InferInsertModel<typeof video_asset>;
export type VideoAssetRecord = VideoAsset;
export type VideoWatchProgress = InferSelectModel<typeof video_watch_progress>;
export type VideoWatchProgressInsert = InferInsertModel<typeof video_watch_progress>;
export type VideoWatchProgressRecord = VideoWatchProgress;
